<template>
  <v-container class="d-flex align-center justify-center py-10">
    <v-card class="pa-8 text-center" max-width="640" width="100%" elevation="2">
      <v-card-title class="text-h4 mb-4 justify-center">
        {{ $t('views.architect.comingSoon.title') }}
      </v-card-title>

      <v-card-text class="text-body-1 mb-6">
        {{ $t('views.architect.comingSoon.message') }}
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="goToDashboard">
          {{ $t('buttons.backToDashboard') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();

function goToDashboard() {
  const fallbackRoute = route.path.startsWith('/structure') ? 'StructureDashboard' : 'ArchitectDashboard';
  router.push({ name: fallbackRoute });
}
</script>
